/**
 * A post-sign-in `redirect` resolved the way the browser resolves it (`/\evil.com` is `//evil.com`),
 * kept only when it stays on this origin; anything else lands on `/`.
 */
export function sameOriginPath(redirect: string | undefined, origin: string = window.location.origin): string {
  if (!redirect) return "/";
  try {
    const u = new URL(redirect, origin);
    return u.origin === origin ? `${u.pathname}${u.search}${u.hash}` : "/";
  } catch {
    return "/";
  }
}
